(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["damda-instant-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('damda-instant-preview')) {
    class DamdaInstantPreview extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.messages = JSON.parse(this.querySelector('[data-dap-messages]').textContent);
        this.file = null;
        this.used = 0;
        this.busy = false;
        this.result = null;
        this.history = [];
        this.ready = false;
        this.session = null;
        this.selectionKey = 'damda.preview.selection.v1';
        this.sessionKey = 'damda.preview.session.v1';
        this.endpoint = /^\/apps\/[a-z0-9/-]+$/i.test(this.dataset.endpoint || '') ? this.dataset.endpoint.replace(/\/$/, '') : '';
        this.q = (selector) => this.querySelector(selector);
        this.events = new AbortController();
        const on = (el, type, fn, capture = false) => el.addEventListener(type, fn, {signal: this.events.signal,capture});
        on(document, 'click', (event) => {
          const trigger = event.target.closest('[data-damda-preview-open]');
          if (!trigger) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open(trigger);
        }, true);
        on(document, 'keydown', (event) => {
          if (event.code === 'Space' && event.target.matches('[data-damda-preview-open]')) {
            event.preventDefault();
            this.open(event.target);
          }
        });
        on(this.q('[data-dap-close]'), 'click', () => this.dialog.close());
        on(this.dialog, 'click', (event) => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        });
        on(this.dialog, 'close', () => {
          document.documentElement.style.overflow = this.previousOverflow;
          this.trigger?.focus({preventScroll:true});
        });
        on(this.q('[data-dap-upload]'), 'click', () => this.q('#dap-photo').click());
        on(this.q('#dap-photo'), 'change', (event) => {
          const file = event.target.files[0];
          event.target.value = '';
          if (file) this.acceptFile(file);
        });
        const drop = this.q('[data-dap-drop]');
        on(drop, 'dragover', (event) => {event.preventDefault();if (!this.busy) drop.classList.add('dap-dragging');});
        on(drop, 'dragleave', () => drop.classList.remove('dap-dragging'));
        on(drop, 'drop', (event) => {
          event.preventDefault();drop.classList.remove('dap-dragging');
          if (!this.busy && event.dataTransfer.files.length === 1) this.acceptFile(event.dataTransfer.files[0]);
        });
        on(this.q('[data-dap-generate]'), 'click', () => this.generate());
        on(this.q('[data-dap-regenerate]'), 'click', () => this.generate());
        on(this.q('[data-dap-use]'), 'click', () => this.select());
        on(this.q('[data-dap-continue]'), 'click', event => {if(this.productHandle){event.preventDefault();this.dialog.close();}});
        on(this.q('[data-dap-retry]'), 'click', () => this.startSession());
        on(this.q('[data-dap-history]'), 'click', (event) => { const button=event.target.closest('[data-dap-preview-id]'); const preview=this.history.find(item=>item.id===button?.dataset.dapPreviewId); if(preview&&!this.busy) this.showResult(preview).then(()=>this.render()).catch(()=>this.status(this.messages.failed,true)); });
        this.render();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        if (this.dialog?.open) {this.dialog.close();document.documentElement.style.overflow = this.previousOverflow;}
        if (this.sourceUrl) URL.revokeObjectURL(this.sourceUrl);
        this.initialized = false;
      }
      async open(trigger) {
        if (this.dialog.open) return;
        this.trigger = trigger;
        this.productHandle = trigger.dataset.productHandle || '';
        this.selectedId = null;
        this.q('[data-dap-continue]').href = this.productHandle ? '/products/'+this.productHandle : '/collections/all';
        this.q('[data-dap-continue]').textContent = this.messages.return_product;
        this.render();
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.q('[data-dap-upload]').focus({preventScroll:true});
        if (this.endpoint && !this.session && !this.busy) await this.startSession();
      }
      status(message = '', error = false) {
        this.q('[data-dap-status]').textContent = message;
        this.q('[data-dap-status]').dataset.error = String(error);
      }
      remember(key, value) {
        try {sessionStorage.setItem(key, JSON.stringify(value));return true;} catch {return false;}
      }
      restore(key) {
        try {return JSON.parse(sessionStorage.getItem(key) || 'null');} catch {return null;}
      }
      async api(path, body) {
        this.request = new AbortController();
        const timer = setTimeout(() => this.request.abort(), 210000);
        try {
          const direct = path === '/generate' && this.generationEndpoint;
          const response = await fetch(direct || this.endpoint + path, {
            method:'POST',credentials:direct ? 'omit' : 'same-origin',cache:'no-store',signal:this.request.signal,
            headers:body instanceof FormData ? {} : {'Content-Type':'application/json'},
            body:body instanceof FormData ? body : JSON.stringify(body)
          });
          if (!(response.headers.get('content-type') || '').includes('application/json')) throw new Error('HTTP_'+response.status);
          const data = await response.json();
          if (Number.isInteger(data.used) && data.used >= 0 && data.used <= 5) this.used = data.used;
          if (!response.ok || data.code) {const error = new Error(data.code || 'failed');error.code = data.code;throw error;}
          return data;
        } finally {clearTimeout(timer);}
      }
      async startSession() {
        this.q('[data-dap-availability]').textContent='Connecting to the preview service…';
        this.busy = true;this.render();
        try {
          const existing = this.restore(this.sessionKey);
          let data;
          try {data = await this.api('/session', {sessionToken:existing?.token || null});}
          catch(error) {if(error.code!=='SESSION_EXPIRED')throw error; data=await this.api('/session',{sessionToken:null});this.history=[];this.result=null;this.selectedId=null;}
          if (!data.sessionToken || !Number.isInteger(data.used) || data.used < 0 || data.used > 5 || data.limit !== 5) throw new Error('invalid_session');
          if(data.generationEndpoint !== 'https://damda-instant-preview.braves31naver.workers.dev/browser/generate')throw new Error('invalid_generation_endpoint');
          this.generationEndpoint=data.generationEndpoint;
          delete this.dataset.connectionError;
          this.session = data.sessionToken;this.used = data.used;this.ready = true;
          this.remember(this.sessionKey, {token:this.session});
          this.q('[data-dap-availability]').textContent = this.messages.ready;
          if (data.preview) await this.showResult(data.preview);
        } catch(error) {this.ready = false;this.q('[data-dap-availability]').textContent=this.messages.offline;this.status(this.messages.offline,true);this.dataset.connectionError=error.code||error.message;}
        finally {this.busy = false;this.render();}
      }
      async acceptFile(file) {
        if (this.busy) return;
        if (!['image/jpeg','image/png'].includes(file.type) || !/\.(jpe?g|png)$/i.test(file.name)) return this.status(this.messages.file_type,true);
        if (!file.size || file.size > 10 * 1024 * 1024) return this.status(this.messages.file_size,true);
        this.busy = true;this.render();
        let url;
        try {
          const bytes = new Uint8Array(await file.slice(0,8).arrayBuffer());
          const png = bytes[0]===137 && bytes[1]===80 && bytes[2]===78 && bytes[3]===71 && bytes[4]===13 && bytes[5]===10 && bytes[6]===26 && bytes[7]===10;
          const jpg = bytes[0]===255 && bytes[1]===216 && bytes[2]===255;
          if ((file.type==='image/png'&&!png)||(file.type==='image/jpeg'&&!jpg)) throw new Error('signature');
          url = URL.createObjectURL(file);
          const image = new Image();image.src = url;await image.decode();
          if (!image.naturalWidth || image.naturalWidth * image.naturalHeight > 40000000) throw new Error('dimensions');
          if (this.sourceUrl) URL.revokeObjectURL(this.sourceUrl);
          this.sourceUrl = url;url = null;this.file = file;this.result = null;this.selectedId = null;
          this.q('[data-dap-source]').src = this.sourceUrl;
          this.q('[data-dap-source]').hidden = false;
          this.q('[data-dap-filename]').textContent = file.name;
          this.q('[data-dap-filename]').hidden = false;
          this.q('#dap-adjustment').value = '';
          this.status(this.ready ? '' : this.messages.offline);
        } catch {if(url) URL.revokeObjectURL(url);this.status(this.messages.file_invalid,true);}
        finally {this.busy = false;this.render();}
      }
      safeUrl(value) {
        const url = new URL(value,location.origin);
        if (url.origin !== location.origin || !url.pathname.startsWith(this.endpoint + '/assets/')) throw new Error('invalid_asset');
        return url.href;
      }
      async showResult(preview) {
        if (!preview?.id || !preview.imageUrl || !preview.expiresAt || Date.parse(preview.expiresAt) <= Date.now()) throw new Error('invalid_preview');
        const url = this.safeUrl(preview.imageUrl);
        const img = this.q('[data-dap-artwork]');
        img.src = url;await img.decode();
        this.result = preview;
        if (!this.history.some(item=>item.id===preview.id)) this.history.push(preview);
        this.q('[data-dap-download]').href = this.safeUrl(preview.downloadUrl || preview.imageUrl);
        this.selectedId = null;
      }
      async generate() {
        if (this.busy || !this.ready || !this.file || this.used >= 5) return;
        this.busy = true;this.generating = true;this.status();this.render();
        try {
          const form = new FormData();
          form.append('photo',this.file);
          form.append('sessionToken',this.session);
          form.append('requestId',crypto.randomUUID());
          form.append('style',this.q('input[name="damda-preview-style"]:checked').value);
          form.append('adjustment',this.used > 0 ? this.q('#dap-adjustment').value.trim() : '');
          const data = await this.api('/generate',form);
          if (!Number.isInteger(data.used) || data.used < 1 || data.used > 5 || data.limit !== 5) throw new Error('invalid_count');
          this.used = data.used;
          await this.showResult(data.preview);
          this.status(this.used === 5 ? this.messages.limit : '');
        } catch(error) {
          if (error.code === 'SESSION_EXPIRED') {this.ready=false;this.status(this.messages.session_expired,true);}
          else this.status(error.code === 'LIMIT_REACHED' ? this.messages.limit : this.messages.failed,true);
        } finally {this.busy=false;this.generating=false;this.render();}
      }
      async select() {
        if (!this.result || this.busy || !this.ready) return;
        this.busy=true;this.status();this.render();
        try {
          const data = await this.api('/select',{sessionToken:this.session,previewId:this.result.id,productHandle:this.productHandle});
          if (!data.selectionToken || data.previewId !== this.result.id || !data.artworkId || !data.artworkUrl || !data.originalPhotoUrl) throw new Error('invalid_selection');
          for(const value of [data.artworkUrl,data.originalPhotoUrl]){const url=new URL(value,location.origin);if(url.origin!==location.origin||!url.pathname.startsWith(this.endpoint+'/order-artworks/'))throw new Error('invalid_artwork');}
          const selection = {version:2,previewId:data.previewId,artworkId:data.artworkId,artworkUrl:data.artworkUrl,originalPhotoUrl:data.originalPhotoUrl,style:data.style,selectedAt:new Date().toISOString(),productHandle:this.productHandle};
          const saved = this.remember(this.selectionKey,selection);
          this.selectedId=data.previewId;
          this.dispatchEvent(new CustomEvent('damda:preview-selected',{bubbles:true,detail:selection}));
          this.status(saved ? (this.productHandle ? this.messages.saved : this.messages.saved_choose) : this.messages.storage);
        } catch {this.status(this.messages.failed,true);}
        finally {this.busy=false;this.render();}
      }
      render() {
        this.q('[data-dap-generate]').disabled = this.busy || !this.ready || !this.file || this.used >= 5;
        this.q('[data-dap-regenerate]').disabled = this.busy || !this.ready || !this.file || this.used >= 5;
        this.q('[data-dap-use]').disabled = this.busy || !this.result || this.selectedId === this.result?.id;
        this.q('[data-dap-use] span').textContent = this.selectedId && this.selectedId === this.result?.id ? this.messages.selected : this.messages.use;
        this.q('[data-dap-upload]').disabled = this.busy;
        this.q('[data-dap-retry]').hidden = this.ready || this.busy;
        this.q('[data-dap-retry]').disabled = this.busy;
        this.querySelectorAll('.dap-style input,#dap-adjustment').forEach(el=>el.disabled=this.busy);
        this.q('[data-dap-adjustments]').hidden = this.used === 0;
        this.q('[data-dap-count]').textContent = this.messages.counter.replace('__COUNT__',String(this.used));
        this.querySelectorAll('.dap-dots i').forEach((dot,i)=>dot.classList.toggle('dap-used',i<this.used));
        this.q('[data-dap-empty]').hidden = !!this.result;
        this.q('[data-dap-artwork]').hidden = !this.result;
        this.q('[data-dap-actions]').hidden = !this.result;
        const history=this.q('[data-dap-history]');history.hidden=!this.history.length;history.replaceChildren(...this.history.map(preview=>{const button=document.createElement('button'),img=document.createElement('img');button.type='button';button.dataset.dapPreviewId=preview.id;button.setAttribute('aria-label','View preview');button.setAttribute('aria-current',String(preview.id===this.result?.id));img.src=this.safeUrl(preview.imageUrl);img.alt='';button.append(img);return button;}));
        this.q('[data-dap-loading]').hidden = !this.generating;
        this.q('[data-dap-result]').setAttribute('aria-busy',String(!!this.generating));
        const selected = !!this.selectedId && this.selectedId === this.result?.id;
        this.q('[data-dap-product-chooser]').hidden = !selected || !!this.productHandle;
        this.q('[data-dap-continue]').hidden = !selected || !this.productHandle;
      }
    }
    customElements.define('damda-instant-preview',DamdaInstantPreview);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["damda-product-personalizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('damda-product-personalizer')) {
    class DamdaProductPersonalizer extends HTMLElement {
      connectedCallback() {
        this.form=this.closest('form');
        this.key='damda.preview.product.v2.'+this.dataset.productHandle;
        this.events?.abort();this.events=new AbortController();
        document.addEventListener('damda:preview-selected',event=>{
          if(event.detail.productHandle===this.dataset.productHandle)this.apply(event.detail);
        },{signal:this.events.signal});
        this.form.addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();const button=this.form.querySelector('[data-damda-add]');if(button&&!button.disabled)this.addToCart(button);else this.validate();},{capture:true,signal:this.events.signal});
        this.form.addEventListener('click',event=>{const button=event.target.closest('[data-damda-add]');if(button){event.preventDefault();this.addToCart(button);}},{signal:this.events.signal});
        try{
          const saved=JSON.parse(sessionStorage.getItem(this.key)||'null');
          const general=JSON.parse(sessionStorage.getItem('damda.preview.selection.v1')||'null');
          const inherited=general?.version===2&&!general.productHandle;
          const newer=inherited&&(!saved||Date.parse(general.selectedAt)>Date.parse(saved.selectedAt));
          if(newer)this.apply({...general,productHandle:this.dataset.productHandle});else if(saved)this.apply(saved);
        }catch{}
      }
      disconnectedCallback(){this.events?.abort();}
      safeAsset(value){
        const url=new URL(value,location.origin);
        if(url.origin!==location.origin||!/^\/apps\/damda-preview\/order-artworks\/[0-9a-f-]{36}$/.test(url.pathname)||!/^[A-Za-z0-9_-]{43}$/.test(url.searchParams.get('key')||''))throw new Error('invalid_artwork');
        return url.href;
      }
      apply(selection){
        try{
          if(selection.version!==2||selection.productHandle!==this.dataset.productHandle||!selection.artworkId||!['classic','soft','vibrant'].includes(selection.style))return;
          const artwork=this.safeAsset(selection.artworkUrl),original=this.safeAsset(selection.originalPhotoUrl);
          this.selection={...selection,artworkUrl:artwork,originalPhotoUrl:original};
          const properties={'_Watercolor artwork':artwork,'_Original photo':original,'Artwork':'Selected watercolor','Watercolor style':selection.style,'_Damda artwork ID':selection.artworkId};
          for(const [key,value] of Object.entries(properties)){
            let input=Array.from(this.querySelectorAll('input[type=hidden]')).find(input=>input.name==='properties['+key+']');
            if(!input){input=document.createElement('input');input.type='hidden';input.name='properties['+key+']';this.append(input);}input.value=value;
          }
          this.querySelector('[data-damda-thumbnail]').src=artwork;
          this.querySelector('[data-damda-selected]').hidden=false;
          this.querySelector('[data-damda-style]').textContent=selection.style.charAt(0).toUpperCase()+selection.style.slice(1)+' watercolor';
          this.querySelector('[data-damda-personalizer-status]').textContent='Your watercolor is selected. Confirm your size, then add to cart.';
          this.querySelector('[data-damda-personalizer-status]').dataset.error='false';
          try{sessionStorage.setItem(this.key,JSON.stringify(this.selection));}catch{}
        }catch{this.selection=null;}
      }
      validate(){
        if(this.selection)return true;
        const status=this.querySelector('[data-damda-personalizer-status]');
        status.textContent='Please create your watercolor and click Use This Preview first.';status.dataset.error='true';
        this.querySelector('[data-damda-preview-open]').focus({preventScroll:true});
        return false;
      }
      async addToCart(button){
        if(this.adding||!this.validate())return;
        this.adding=true;button.disabled=true;
        const status=this.querySelector('[data-damda-personalizer-status]');
        try{
          const form=new FormData(this.form);
          const picker=Array.from(document.querySelectorAll('variant-picker')).find(el=>el.dataset.productHandle===this.dataset.productHandle);
          const checked=picker?.querySelectorAll('input[type=radio]:checked');
          const selectedVariant=checked?.length===1?checked[0].dataset.variantId:null;
          const id=Number(selectedVariant||form.get('id')||this.dataset.defaultVariant),quantity=Number(form.get('quantity')||1);
          if(!Number.isSafeInteger(id)||id<=0||!Number.isSafeInteger(quantity)||quantity<1)throw new Error('Please confirm your size and quantity.');
          const properties={'_Watercolor artwork':this.safeAsset(this.selection.artworkUrl),'_Original photo':this.safeAsset(this.selection.originalPhotoUrl),'Artwork':'Selected watercolor','Watercolor style':this.selection.style,'_Damda artwork ID':this.selection.artworkId};
          for(const key of ['Personalization note','Special requests']){const value=form.get('properties['+key+']');if(typeof value==='string'&&value.trim())properties[key]=value;}
          status.textContent='Adding your selected watercolor to your cart…';
          const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity,properties}]})});
          const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||'Could not add this product. Please try again.');
          location.assign(this.dataset.cartUrl);
        }catch(error){status.textContent=error.message||'Could not add this product. Please try again.';status.dataset.error='true';this.adding=false;button.disabled=false;}
      }
    }
    customElements.define('damda-product-personalizer',DamdaProductPersonalizer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["damda-size-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const link=event.target.closest('[data-damda-size-link]');if(!link)return;
  const selection=document.querySelector('damda-product-personalizer')?.selection;
  if(selection)try{sessionStorage.setItem('damda.preview.selection.v1',JSON.stringify({...selection,productHandle:'',selectedAt:new Date().toISOString()}));}catch{}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["damda-usa-seal"] && !Shopify.designMode) return;
  try {
    (() => {
    const productNames = [
      'Gallery-Wrapped Canvas',
      'AirFrame Print',
      'Keepsake Pillow',
      'House Portrait Mug',
      'Kitchen Hand Towel'
    ];

    const productLinks = [
      '/products/personalized-watercolor-house-portrait-canvas',
      '/products/personalized-watercolor-house-portrait-airframe-14-x-11',
      '/products/personalized-watercolor-house-portrait-pillow-14-x-14',
      '/products/personalized-watercolor-house-portrait-mug-11-oz',
      '/products/personalized-watercolor-house-portrait-kitchen-hand-towel'
    ];

    const productCtas = [
      'Explore the canvas \u2192',
      'Explore the AirFrame print \u2192',
      'Explore the pillow \u2192',
      'Explore the mug \u2192',
      'Explore the kitchen hand towel \u2192'
    ];

    const productAssets = ['canvas', 'frame', 'pillow', 'mug', 'towel'];
    const dotPositions = [
      ['56%', '13%'],
      ['80%', '17%'],
      ['57%', '45%'],
      ['41%', '70%'],
      ['38%', '50%']
    ];

    const mountDamdaProductZones = () => {
      const stage = document.querySelector('#damda-collection .room-stage');
      const assets = document.querySelector('#DamdaRoomAssetsTemplate');

      if (!stage || !assets) return;

      const roomImage = stage.querySelector(':scope > img');
      if (roomImage) {
        roomImage.src = assets.dataset.background;
        roomImage.removeAttribute('srcset');
        roomImage.width = 1600;
        roomImage.height = 900;
        roomImage.alt = 'Warm neutral living room displaying the Damda home portrait collection';
      }

      const firstDot = stage.querySelector('.room-dot');

      productNames.forEach((name, index) => {
        let zone = stage.querySelector(`.damda-product-zone--${index}`);
        if (!zone) {
          zone = document.createElement('button');
          zone.className = `damda-product-zone damda-product-zone--${index}`;
          zone.type = 'button';
          zone.setAttribute('aria-label', `Select ${name}`);
          zone.title = name;
          zone.addEventListener('click', () => {
            const input = document.querySelector(`#room-piece-${index}`);
            if (input) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          stage.insertBefore(zone, firstDot);
        }

        let productImage = stage.querySelector(`.damda-product-item--${index}`);
        if (!productImage) {
          productImage = document.createElement('img');
          productImage.className = `damda-product-item damda-product-item--${index}`;
          productImage.src = assets.dataset[productAssets[index]];
          productImage.alt = '';
          productImage.loading = index < 2 ? 'eager' : 'lazy';
          productImage.decoding = 'async';
          productImage.setAttribute('aria-hidden', 'true');
          stage.insertBefore(productImage, firstDot);
        }
      });

      stage.querySelectorAll('.room-dot').forEach((dot, index) => {
        if (!dotPositions[index]) return;
        dot.style.left = dotPositions[index][0];
        dot.style.top = dotPositions[index][1];
      });
    };

    const mountDamdaUsaSeal = () => {
      const heading = document.querySelector('#damda-collection h2');
      const template = document.querySelector('#DamdaUsaSealTemplate');

      if (!heading || !template || heading.parentElement?.classList.contains('damda-collection-heading-row')) return;

      const row = document.createElement('div');
      row.className = 'damda-collection-heading-row';
      heading.before(row);
      row.append(heading, template.content.cloneNode(true));
    };

    const mountDamdaProductLinks = () => {
      document.querySelectorAll('#damda-collection .room-panel').forEach((panel, index) => {
        if (!productLinks[index]) return;

        const content = panel.querySelector(':scope > div');
        const status = panel.querySelector('.piece-status');
        if (!content) return;

        if (status) status.textContent = 'AVAILABLE NOW';

        let link = content.querySelector('a');
        if (!link) {
          link = document.createElement('a');
          content.append(link);
        }

        link.href = productLinks[index];
        link.textContent = productCtas[index];
      });
    };

    const mountDamdaCollectionCtas = () => {
      document.querySelector('.damda-video-hero__cta')?.remove();

      const collectionLink = document.querySelector('#damda-collection .room-pricing-button');
      if (!collectionLink) return;

      const label = collectionLink.querySelector('span');
      if (label) label.textContent = 'Explore the Collection';
      collectionLink.setAttribute('aria-label', 'Explore the Collection');
      collectionLink.href = '/collections/all';
    };

    const mountDamdaBeyond = () => {
      const main = document.querySelector('#MainContent');
      const template = document.querySelector('#DamdaBeyondTemplate');
      if (!main || !template) return;

      const faq = document.querySelector('.damda-faq');

      const existing = document.querySelector('.damda-beyond');
      if (existing) {
        if (faq && existing.nextElementSibling !== faq) faq.before(existing);
        else if (!faq && main.lastElementChild !== existing) main.append(existing);
        return;
      }

      const content = template.content.cloneNode(true);
      if (faq) faq.before(content);
      else main.append(content);
    };

    const mountDamdaPreviewAnchor = () => {
      const preview = document.querySelector('.damda-preview-launch');
      if (preview) preview.id = 'damda-preview-launch';
    };

    const mountDamdaStoryTypography = () => {
      const headings = [
        ['.damda-story__heading', 'Turn a meaningful home into ', 'a one-of-a-kind watercolor keepsake.'],
        ['#damda-lifestyle-title', 'A home can stay with you, ', 'even after you leave it.'],
        ['.damda-lifestyle__feature:not(.damda-lifestyle__feature--reverse) .damda-lifestyle__copy h3', 'The walls that knew ', 'your story.'],
        ['.damda-lifestyle__feature--reverse .damda-lifestyle__copy h3', 'Bring a memory, ', 'not just a gift.'],
        ['#damda-use-title', 'One portrait. ', 'So many meaningful reasons.']
      ];
      headings.forEach(([selector, lead, accent]) => {
        const heading = document.querySelector(selector);
        if (!heading || heading.dataset.damdaStoryTypography ||
            heading.textContent.trim() !== (lead + accent).trim()) return;
        const emphasis = document.createElement('em');
        emphasis.textContent = accent;
        heading.replaceChildren(document.createTextNode(lead), emphasis);
        heading.dataset.damdaStoryTypography = 'true';
      });
      document.querySelectorAll('.damda-process-card h3').forEach((heading) => {
        if (heading.querySelector('.damda-story-step-number')) return;
        const lineBreak = heading.querySelector('br');
        const first = heading.firstChild;
        if (!lineBreak || !first || first.nodeType !== Node.TEXT_NODE ||
            !/^0[1-3]$/.test(first.textContent.trim())) return;
        const number = document.createElement('span');
        number.className = 'damda-story-step-number';
        number.textContent = first.textContent.trim();
        first.replaceWith(number);
        lineBreak.remove();
      });
    };


    const mountDamdaUnifiedCtas = () => {
      document.querySelectorAll('#MainContent a').forEach((link) => {
        if (!/^Explore the Collection(?:\s*→)?$/i.test(link.textContent.trim())) return;
        link.classList.add('damda-collection-cta');
        link.href = '/collections/all';
        ['role', 'aria-haspopup', 'aria-controls', 'data-damda-preview-open'].forEach((attribute) => {
          link.removeAttribute(attribute);
        });
        if (link.querySelector('.damda-collection-cta__arrow')) return;
        const label = document.createElement('span');
        label.textContent = 'Explore the Collection';
        const arrow = document.createElement('span');
        arrow.className = 'damda-collection-cta__arrow';
        arrow.textContent = '→';
        arrow.setAttribute('aria-hidden', 'true');
        link.replaceChildren(label, arrow);
      });
    };

    const mountDamdaEnhancements = () => {
      mountDamdaUsaSeal();
      mountDamdaProductZones();
      mountDamdaProductLinks();
      mountDamdaCollectionCtas();
      mountDamdaBeyond();
      mountDamdaPreviewAnchor();
      mountDamdaStoryTypography();
      mountDamdaUnifiedCtas();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountDamdaEnhancements, { once: true });
    } else {
      mountDamdaEnhancements();
    }

    document.addEventListener('shopify:section:load', () => {
      mountDamdaUsaSeal();
      mountDamdaProductZones();
      mountDamdaProductLinks();
      mountDamdaCollectionCtas();
      mountDamdaBeyond();
      mountDamdaPreviewAnchor();
      mountDamdaStoryTypography();
      mountDamdaUnifiedCtas();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
